import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useSummaryCardStyles } from './summaryCard.style';

const SummaryCard = ({ Icon, title, subtitle }) => {
  const classes = useSummaryCardStyles();

  return (
    <Grid container classes={{ root: classes.cardContainer }}>
      <Grid item xs={12} classes={{ root: classes.container }}>
        <Icon classes={{ root: classes.icon }} />
        <div className={classes.contentContainer}>
          <Typography classes={{ root: classes.title }}>{title}</Typography>
          <Typography classes={{ root: classes.subtitle }}>
            {subtitle}
          </Typography>
        </div>
      </Grid>
    </Grid>
  );
};

export default SummaryCard;
